<template>
	<layout>
		<div class="login-container">
			<div class="login-card">
				<div class="form-section">
					<form class="form-box" id="login">
						<div class="form-header">
							<div class="form-title">{{ $t('login.f.login-to-app') }}</div>
							<div class="form-description">{{ $t('login.f.enter-username-password') }}</div>
						</div>
						<div class="form-fields">
							<div class="field-container">
								<div class="field error" v-if="message">
									<icon icon="info-circle" group="regular" class="alert-icon" />
									<div class="error-msg">
										<div class="text-bold">{{ $t('login.m.login-failed') }}</div>
										<div>{{ message }}</div>
									</div>
									<icon icon="times" class="close-icon" @click="clearMessage()" />
								</div>

								<div class="field username">
									<nk-input :options="inputOptions('text', 'username')" autofocus v-model="username"></nk-input>
									<icon class="placeholder-icon" name="user" group="light" />
								</div>
								<div class="field password position-relative">
									<nk-input id="id_password" :options="inputOptions('password', 'password')" autofocus v-model="password"></nk-input>
									<icon class="placeholder-icon" name="lock" group="light" />
									<i @click="showPassword" id="togglePassword" class="placeholder-icon fal fa-eye eye"></i>
								</div>
							</div>
							<div class="change-form-status" @click="switchCard('recovery')">
								{{ $t('login.f.forgot-password') }}
							</div>
						</div>
						<div class="buttons">
							<button @click="login" v-if="!spinning" type="submit">{{ $t('login.buttons.submit') }}
							</button>
							<div v-else class="sk-chase">
								<div class="sk-chase-dot"></div>
								<div class="sk-chase-dot"></div>
								<div class="sk-chase-dot"></div>
								<div class="sk-chase-dot"></div>
							</div>
						</div>
					</form>

					<form class="form-box" id="recovery">
						<div class="form-header">
							<div class="form-title">{{ $t('login.f.password-recovery') }}</div>
							<!-- <div class="form-description">به منظور بازیابی کلمه عبور، ایمیل خود را وارد کنید</div> -->
						</div>
						<div class="form-fields">
							<div class="field-container">
								<div class="field error" v-if="message">
									<icon icon="info-circle" group="regular" class="alert-icon" />
									<div class="error-msg">
										<div class="text-bold">{{ $t('login.m.error') }}</div>
										<div>{{ message }}</div>
									</div>
									<icon icon="times" class="close-icon" @click="clearMessage()" />
								</div>

								<div class="field username">
									<icon class="placeholder-icon" name="envelope" group="light" />
									<nk-input :options="inputOptions('text', 'email-or-phone')" autofocus v-model="recoveryData"></nk-input>
								</div>

							</div>
							<div class="change-form-status" @click="switchCard('login')">
								{{ $t('login.f.back-to-login') }}
							</div>
						</div>
						<div class="buttons">
							<button @click="recoverPassword" v-if="!spinning" type="submit">{{ $t('login.buttons.recovery') }}
							</button>
							<div v-else class="sk-chase">
								<div class="sk-chase-dot"></div>
								<div class="sk-chase-dot"></div>
								<div class="sk-chase-dot"></div>
								<div class="sk-chase-dot"></div>
							</div>
						</div>
					</form>
				</div>
				<div class="business-section">
					<div class="nikan-logo-container">
						<img class="h-100 w-100" src="../../assets/logo-white.png" />
					</div>
					<div class="business-details">
						<div class="business-name">
							{{ $t('login.f.image-title') }}
						</div>
						<div class="business-description">
							<div class="business-nikan">{{ $t('login.f.nikan') }}</div>
							<div> {{ $t('login.f.business-description') }}</div>
						</div>
					</div>
					<div class="business-apps">
						<InfiniteScroller :items="businessItems"></InfiniteScroller>
					</div>
				</div>
			</div>
		</div>
	</layout>
</template>
<script>
	import Layout from '~/views/shared/_layout-login'
	import { mapActions, mapGetters } from 'vuex'
	import $ from 'jquery'
	import { post } from '~/plugins/nikan-api'
	import Endpoints from '@nikan/endpoints'
	import googleSignInButton from '~/components/general/google-signin-button.vue'
	import confetti from "canvas-confetti"
	import InfiniteScroller from '@/components/Infinite-scroller/Infinite-scroller.vue'
	import logoPakhsh from '@/assets/app-logos/app-pakhsh.webp'
	import logoTolid from '@/assets/app-logos/app-tolid.webp'
	import logoBazargani from '@/assets/app-logos/app-bazargani.webp'
	import logoPeyman from '@/assets/app-logos/app-peyman.webp'
	import logoSandugh from '@/assets/app-logos/app-sandugh.webp'

	export default {
		modal: {
			helpTag: 'Login'
		},
		components: {
			Layout,
			InfiniteScroller,
			'g-signin-button': googleSignInButton
		},
		created() {
			this.nikanUser = (JSON.parse(window.localStorage.getItem('nikan-user'))?.useraccount)
		},
		mounted() {
			$('#recovery').hide()
		},
		data() {
			return {
				nikanUser: null,
				isSignInEnabled: import.meta.env.VITE_GSIGNIN_STATUS === 'enabled',
				isCaptchaEnabled: import.meta.env.VITE_CAPTCHA_STATUS === 'enabled',
				username: null,
				password: null,
				message: null,
				spinning: false,
				recoveryData: null,
				loginRecaptchatoken: '',
				recoveryRecaptchatoken: '',
				isTrue: false,
				googleSignInParams: {
					clientId: import.meta.env.VITE_GSIGNIN_CLIENT_ID
				},
			}
		},
		computed: {
			...mapGetters('useraccount', ['currentUser']),
			businessItems() {
				return [
					{ link: '#', title: this.$t('login.apps.distribution'), image: logoPakhsh },
					{ link: '#', title: this.$t('login.apps.manufacturing'), image: logoTolid },
					{ link: '#', title: this.$t('login.apps.commerce'), image: logoBazargani },
					{ link: '#', title: this.$t('login.apps.contracting'), image: logoPeyman },
					{ link: '#', title: this.$t('login.apps.fund'), image: logoSandugh },
				]
			}
		},
		methods: {
			...mapActions('useraccount', ['authenticateUser', 'clearCustomer']),
			inputOptions(inputType, field) {
				return {
					mode: inputType,
					placeholder: this.$t(`login.f.${field}`),
					height: '45px'
				}
			},
			changeCustomer() {
				this.clearCustomer()
				this.$router.push({ name: 'launcher' })
			},
			onSignInSuccess(response, event) {
				this.loginByGoogle(`googletoken=${response.getAuthResponse().id_token}`)
			},
			onSignInError(error) {
				this.$toast(this.$t('login.m.google-login-failed'), { type: 'error' })
			},
			showPassword() {
				const togglePassword = $('#togglePassword')
				const password = $($('#id_password').children()[0])

				const type = password.attr('type') === 'password' ? 'text' : 'password'
				password.attr('type', type)
				togglePassword.toggleClass('fa-eye-slash')
			},
			switchCard(card) {
				this.message = ''
				switch (card) {
					case 'login':
						$('#recovery').fadeOut(150, () => {
							$('#login').fadeIn(200)
						})
						break
					case 'recovery':
						$('#login').fadeOut(150, () => {
							$('#recovery').fadeIn(200)
						})
						break
					default:
						break
				}
			},
			recoverPassword(event) {
				const emailRegex = /.*@.*\..*/g
				const phoneRegex = /^09[0-9]{9}$/g
				event.preventDefault()
				if (!this.recoveryData) {
					this.message = this.$t('login.m.IncompleteFields')
					return
				}
				if (this.isCaptchaEnabled && !this.recoveryRecaptchatoken.length) {
					this.message = this.$t('login.m.recaptcha-unfilled')
					return
				}
				if (!emailRegex.test(this.recoveryData) && !phoneRegex.test(this.recoveryData)) {
					this.message = this.$t('login.m.email-or-phone-invalid')
					return
				}
				this.spinning = true

				post(Endpoints.getUrl('user.sendRecoveryEmail'), { Email: this.recoveryData, RT: this.recoveryRecaptchatoken }, null, { silent: true, ignoreCommercialAccess: true })
					.then((result) => {
						this.$toast(this.$t('login.m.recovery-email-send'), { type: 'success' })
						setTimeout(() => {
							this.spinning = false
						}, 2000)
						setTimeout(() => {
							this.switchCard('login')
						}, 2000)
					})
					.catch(err => {
						this.$toast(err.message, { type: 'error' })
						setTimeout(() => {
							this.spinning = false
						}, 2000)
					})
			},
			login(event) {
				event.preventDefault()
				if (!this.password || !this.username) {
					this.message = this.$t('login.m.IncompleteFields')
					return
				}
				if (this.isCaptchaEnabled && !this.loginRecaptchatoken.length) {
					this.message = this.$t('login.m.recaptcha-unfilled')
					return
				}
				this.submit(this.username, this.password)
			},
			loginByGoogle(token) {
				this.submit(token, '')
			},
			submit(username, password) {
				this.spinning = true

				const payload = {
					username: username,
					password: password,
					RT: this.loginRecaptchatoken
				}

				this.authenticateUser(payload)
					.then((result) => {
						//confetti()
						setTimeout(() => {
							const query = this.$route.query
							if (query && query.next)
								this.$router.push({ name: 'page', params: { page: query.next }, query })
							else
								this.$router.push({ name: 'home' })
						}, 100)
					})
					.catch((error) => {
						if (error.response && error.response.data.message)
							this.message = this.$t(`login.m.${error.response.data.message}`)
						else
							this.message = this.$t('login.m.login-failed')

					})
					.finally(() => {
						setTimeout(() => {
							this.spinning = false
						}, 2000)
					})
			},
			clearMessage() {
				this.message = null
			}
		},
	}
</script>
<style src="~/styles/login.less" lang="less"></style>
